import { PayloadAction } from '@reduxjs/toolkit';
import { Nullish } from '@snap-types/types/nullish';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

interface Params extends QuoteLineParams {
  specs: Nullish<string>;
}
export function quoteLineSpecsChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const { quoteLineUuid, specs } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.specs = specs;
}
